import { Component, OnInit } from '@angular/core';
import { ErrorManagerService } from './error-manager.service';

@Component({
  selector: 'dm-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  error: any;

  constructor(private errorManager: ErrorManagerService) { }

  ngOnInit() {
    if (this.errorManager.errorCurrentParrentKey) {
      const errors = this.errorManager.errorCurrentParrentKey === 'feeds_list'
        ? this.errorManager.dataMinerUiErrors.feeds_list
        : this.errorManager.dataMinerUiErrors.explore_data_set;

      if (errors) {
        this.error = errors[0].error.message;
      }
    }
  }

  errorRefresh() {
    location.reload(true);
  }

  closeError() {
    this.error = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/error-handling/error.component.ts